import React, { useEffect } from "react";

import useLayoutStore from "store/useLayoutStore";
import { ErrorDisplay } from "container/Error/ErrorDisplay";
const ErrorDisplayPage = () => {
  const { setLayout } = useLayoutStore();

  useEffect(() => {
    setLayout({ isHeader: false, isSubTab: false });
  }, []);
  return (
    <>
      <ErrorDisplay />
    </>
  );
};

export default ErrorDisplayPage;
